import { render, staticRenderFns } from "./NoticeExport.vue?vue&type=template&id=6988bebc&scoped=true"
import script from "./NoticeExport.vue?vue&type=script&lang=js"
export * from "./NoticeExport.vue?vue&type=script&lang=js"
import style0 from "./NoticeExport.vue?vue&type=style&index=0&id=6988bebc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6988bebc",
  null
  
)

export default component.exports